import { Check } from "lucide-react";
import type { FC } from "react";

import type { Item } from "./type";

interface StepIndicatorProps {
  step: Item;
  isLast: boolean;
}

const StepIndicator: FC<StepIndicatorProps> = ({ step, isLast }) => {
  const { id, name, done, active } = step;
  const stepColor = active || done ? "text-gray-950" : "text-gray-300";
  const lineColor = done && !isLast ? "bg-gray-950" : "bg-gray-300";

  return (
    <>
      <div className={`flex gap-4 transition-colors duration-300 ${stepColor}`}>
        <div className="flex flex-col items-center gap-1">
          <div
            className={`flex justify-center items-center w-4 h-4 sm:w-6 sm:h-6 rounded-full transition-all duration-300 ${
              active
                ? "bg-gray-950 text-white scale-110"
                : done
                  ? "border border-gray-950 bg-transparent text-black scale-100"
                  : "border border-gray-300 bg-white text-gray-300 scale-100"
            }`}
          >
            {done ? (
              <Check className="w-2 h-2 sm:w-4 sm:h-4 animate-fade-in" />
            ) : (
              <span className="transition-opacity duration-300">{id}</span>
            )}
          </div>
          <span
            className={`text-sm whitespace-nowrap transition-all duration-300 ${
              active ? "font-bold scale-105" : "font-normal scale-100"
            }`}
          >
            {name}
          </span>
        </div>
      </div>
      {!isLast && (
        <div
          className={`w-full h-[1px] self-start mt-[11px] transition-colors duration-500 ${lineColor}`}
        ></div>
      )}
    </>
  );
};

export default StepIndicator;
